import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { getDisplayName } from 'helpers/component';

export default function PageTitleEnhancer({ pageTitle, showGGBranding } = {}) {
    const returnPageTitle = (page, isGWG, entityName) => {
        const dashTitle = `${page} - ${entityName || 'Performance Dashboard'}${isGWG ? ' | Goodway Group' : ''}`;
        const adminTitle = `${page} - Admin${isGWG ? ' | Goodway Group' : ''}`;
        const title = document.URL.toLowerCase().indexOf('admin') === -1 ? dashTitle : adminTitle;
        return title;
    };

    const updateTitle = (props) => {
        const { entityName, embeddedLinks } = props;
        const isCustom = pageTitle === 'Custom';

        let customPageTitle;
        if (isCustom && embeddedLinks.length > 0) {
            const matchedLink = embeddedLinks.filter(link => document.URL.toLowerCase().includes(link.slug));
            if (matchedLink.length > 0) {
                customPageTitle = matchedLink[0].name;
            }
        }
        let showGWG;
        if (typeof showGGBranding === 'undefined') {
            showGWG = props.showGGBranding;
        } else {
            showGWG = showGGBranding;
        }
        document.title = returnPageTitle(isCustom ? customPageTitle : pageTitle, showGWG, entityName);
    };

    return function PageTitleHOC(WrappedComponent) {
        class PageTitle extends React.Component {
            componentDidMount() {
                updateTitle(this.props);
            }

            componentDidUpdate() {
                updateTitle(this.props);
            }

            render() {
                // Wraps the input component in a container, without mutating it. Good!
                return <WrappedComponent {...this.props} />;
            }
        }

        const mapStateToProps = state => ({
            showGGBranding: !get(state, 'entities.meta.meta.whitelabel.hideGGBranding'),
            entityName: get(state, 'entities.meta.name', null),
            embeddedLinks: get(state, 'entities.meta.embeddedLinks', [])
        });

        PageTitle.displayName = `PageTitle(${getDisplayName(WrappedComponent)})`;

        return connect(mapStateToProps, {})(PageTitle);
    };
}



// WEBPACK FOOTER //
// ./src/hoc/PageTitle.js